import axios, { type AxiosError } from 'axios';
// import { ENV } from '@config';
import { useAuthStore } from '@app/stores';

export const apiClient = axios.create({
  baseURL:
    import.meta.env.VITE_API_BASE_URL || 'https://api.sanctumofsorcery.com',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as any;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        await useAuthStore.getState().refreshToken();
        const token = useAuthStore.getState().accessToken;
        if (token) {
          originalRequest.headers.Authorization = `Bearer ${token}`;
        }
        return apiClient(originalRequest);
      } catch (refreshError) {
        useAuthStore.getState().logout().catch(console.error);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
